export default function offerSimilarsOptionsResolver({ offer, itemSettings, offerSettings, on }) {
    return {
        bind: {
            offer,
            settings: itemSettings,
            similarsSettings: offerSettings.similars,
        },
        on: {
            'similar-click-handler': on.similarClickHandler,
        },
    };
}
